import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import DevicesIcon from "@mui/icons-material/Devices";
import BuildIcon from "@mui/icons-material/Build";
import PersonIcon from "@mui/icons-material/Person";
import { useLocation, useNavigate } from "react-router-dom";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const value = (() => {
    if (location.pathname.includes("/devices")) return 1;
    if (location.pathname.includes("/claims")) return 2;
    if (location.pathname.includes("/profile")) return 3;
    return 0;
  })();

  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        pt: 2.5, // Adds ~12px of padding at the top
        pb: 0.5, // Optional: slight bottom padding for balance
        borderRadius: "20px 20px 0 0", // Optional: rounded top corners for modern UI
        backgroundColor: "#ffffff",
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(e, v) => {
          if (v === 0) navigate("/cust");
          if (v === 1) navigate("/cust/devices");
          if (v === 2) navigate("/cust/claims");
          if (v === 3) navigate("/cust/profile");
        }}
        showLabels
      >
        <BottomNavigationAction label="Home" icon={<HomeIcon />} />
        <BottomNavigationAction label="Devices" icon={<DevicesIcon />} />
        <BottomNavigationAction label="Claims" icon={<BuildIcon />} />
        <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
      </BottomNavigation>
    </Paper>
  );
}




// // src/layout/BottomNav.jsx
// import {
//   BottomNavigation,
//   BottomNavigationAction,
// } from "@mui/material";

// import HomeIcon from "@mui/icons-material/Home";
// import DevicesIcon from "@mui/icons-material/Devices";
// import BuildIcon from "@mui/icons-material/Build";
// import PersonIcon from "@mui/icons-material/Person";

// export default function BottomNav({ tab, setTab }) {
//   return (
//     <BottomNavigation
//       value={tab}
//       onChange={(e, v) => setTab(v)}
//       showLabels
//     >
//       <BottomNavigationAction label="Home" icon={<HomeIcon />} />
//       <BottomNavigationAction label="Devices" icon={<DevicesIcon />} />
//       <BottomNavigationAction label="Claims" icon={<BuildIcon />} />
//       <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
//     </BottomNavigation>
//   );
// }




// import React from "react";
// import { Home, Smartphone, Wrench, User } from "lucide-react";

// const items = [
//   { key: 0, label: "Home", icon: Home },
//   { key: 1, label: "Devices", icon: Smartphone },
//   { key: 2, label: "Claims", icon: Wrench },
//   { key: 3, label: "Profile", icon: User },
// ];

// export default function BottomNav({ tab, setTab }) {
//   return (
//     <div className="sticky bottom-0 z-40 bg-white border-t border-slate-200">
//       <div className="grid grid-cols-4">
//         {items.map((it) => {
//           const Icon = it.icon;
//           const active = tab === it.key;
//           return (
//             <button
//               key={it.key}
//               onClick={() => setTab(it.key)}
//               className={[
//                 "py-2.5 flex flex-col items-center gap-1 text-xs font-semibold",
//                 active ? "text-indigo-600" : "text-slate-600",
//               ].join(" ")}
//             >
//               <Icon size={18} />
//               {it.label}
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// }


